import { getSecondary } from '@brands/Utils/getPrimaryColor';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import React from 'react';

import styles from './styles.module.scss';

type TabItem = {
  label: string;
  value: string;
};

type CustomSx = {
  wrapper?: SxProps<Theme>;
  tabList?: SxProps<Theme>;
  tab?: SxProps<Theme>;
};

type ProfileCommonHeaderProps = {
  currentTab: string;
  handleTabChange: (newTab: string) => void;
  tabs: TabItem[];
  sx?: CustomSx; // ✅ optional styling
  className?: string; // ✅ optional custom class
};

const ProfileCommonHeader = ({
  currentTab,
  handleTabChange,
  tabs,
  sx,
  className,
}: ProfileCommonHeaderProps): JSX.Element => {
  const onTabChange = (event: React.SyntheticEvent, newValue: string): void => {
    event.preventDefault();
    if (newValue !== currentTab) {
      handleTabChange(newValue);
    }
  };

  return (
    <div className={`fs-unmask ${styles.profileCommonHeaderDiv} ${styles[`tabs-${tabs.length}`]} ${className ?? ''}`}>
      <Box sx={{ width: '100%', typography: 'body1', ...sx?.wrapper }}>
        <TabContext value={currentTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={onTabChange}
              aria-label="Profile Tabs"
              sx={sx?.tabList}
              TabIndicatorProps={{
                style: { backgroundColor: getSecondary() },
              }}
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} className="fs-unmask" sx={sx?.tab} />
              ))}
            </TabList>
          </Box>
        </TabContext>
      </Box>
    </div>
  );
};

export default ProfileCommonHeader;
